import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  catInfo: [],
  services: [],
  jobs: [],
  banners: [],
  relatedProds:[],
  relatedServices:[],
  gallery:[], 
  page:[],
  catDropdown:[],
    sitesetting: [],
      defaultAddress: "",
  defaultphones: "",

};

const commonSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.products = action.payload;
    },
    setGallery: (state, action) => {
      state.gallery = action.payload;
    },
    setCurrentCategoryData: (state, action) => {
      state.catInfo = action.payload;
    },
    setRelatedProducts: (state, action) => {
      state.relatedProds = action.payload;
    },
    setServices: (state, action) => {
      state.services = action.payload;
    },
    setBanners: (state, action) => {
      state.banners = action.payload;
    },
    setRelatedServices: (state, action) => {
      state.relatedServices = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setJobs: (state, action) => {
      state.jobs = action.payload;
    },
    setCatDropdown: (state, action) => {
      state.catDropdown = action.payload;
    },
        setsiteSetting: (state, action) => {
      state.sitesetting = action.payload;

      const data = action.payload?.siteSetting?.[0]?.data || {};
      const defaultAddr =
        data.addresses?.find((addr) => addr.isDefault)?.value || "";
      const defaultPhone =
        data.phones?.find((mob) => mob.isDefault)?.value || "";

      state.defaultAddress = defaultAddr;
      state.defaultphones = defaultPhone;
    },
  },
});

export const { setProducts,setCatDropdown, setServices,setGallery, setBanners, setCurrentCategoryData, setRelatedProducts , setRelatedServices , setPage, setJobs,   setsiteSetting,
 } = commonSlice.actions;

export default commonSlice.reducer;
